// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__39u2n","rootSuccess":"CompleteLink_rootSuccess__2B5Wi","rootFailure":"CompleteLink_rootFailure__yU0jL","isDisabled":"CompleteLink_isDisabled__1gZF7"};